import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import './CFSForm.css';

const FormDetail = ({ fieldName, fields }) => {
    const basicField = (
        <Fragment>
            <div className="columns" key={fieldName}>
                <div className="column is-3 field-label">
                    <strong>{fields[fieldName].label}</strong>
                </div>
                <div className="column is-9">{fields[fieldName].value}</div>
            </div>
        </Fragment>
    );

    if (fieldName === 'speakers') {
        return fields.speakers.map(speaker => (
            <Fragment key={speaker.id}>
                <div className="is-divider custom-divider" data-content="Speaker detail" />
                <div className="columns">
                    <div className="column is-3 field-label">
                        <strong>{speaker.speakerName.label}</strong>
                    </div>
                    <div className="column is-9">{speaker.speakerName.value}</div>
                </div>
                <div className="columns">
                    <div className="column is-3 field-label">
                        <strong>{speaker.email.label}</strong>
                    </div>
                    <div className="column is-9">{speaker.email.value}</div>
                </div>
                <div className="columns">
                    <div className="column is-3 field-label">
                        <strong>{speaker.company.label}</strong>
                    </div>
                    <div className="column is-9">{speaker.company.value}</div>
                </div>
                <div className="columns">
                    <div className="column is-3 field-label">
                        <strong>{speaker.country.label}</strong>
                    </div>
                    <div className="column is-9">{speaker.country.value}</div>
                </div>
                <div className="columns">
                    <div className="column is-3 field-label">
                        <strong>{speaker.speakerBio.label}</strong>
                    </div>
                    <div className="column is-9">{speaker.speakerBio.value}</div>
                </div>
                <div className="columns">
                    <div className="column is-3 field-label">
                        <strong>{speaker.photoLink.label}</strong>
                    </div>
                    <div className="column is-9">{speaker.photoLink.value}</div>
                </div>
            </Fragment>
        ));
    }

    if (fieldName === 'talkTitle') {
        return (
            <Fragment>
                <div className="is-divider custom-divider" data-content="Talk detail" />
                {basicField}
            </Fragment>
        );
    }

    if (fieldName === 'twitterPromotion') {
        return (
            <Fragment>
                <div className="is-divider custom-divider" data-content="Social" />
                {basicField}
            </Fragment>
        );
    }

    return basicField;
};

const CFSSummary = ({ fields }) => (
    <div className="summary" id="summary">
        <div>
            {Object.keys(fields).map(field => {
                const fieldRow =
                    field === 'disclaimer' ? (
                        <div className="columns" key={field}>
                            <div className="column is-3 field-label">
                                <strong>Disclaimer accepted</strong>
                            </div>
                            <div className="column is-9 disclaimer">{fields.disclaimer.label}</div>
                        </div>
                    ) : (
                        <FormDetail fieldName={field} fields={fields} key={field} />
                    );

                return fieldRow;
            })}
        </div>
    </div>
);

CFSSummary.propTypes = {
    // eslint-disable-next-line
    fields: PropTypes.object.isRequired
};

export default CFSSummary;
